import { IOption } from '@cian/ui-kit';

import { EIdentificationPersonType } from '../../enums';

export const identificationPersonTypeSelectOptions: Array<IOption<EIdentificationPersonType>> = [
  { label: 'Физическое лицо', value: EIdentificationPersonType.Natural },
  { label: 'ИП', value: EIdentificationPersonType.Ip },
  { label: 'Компания', value: EIdentificationPersonType.Legal },
];
